import dayjs from 'dayjs'
import { ANALYTICS_TTL } from '@super-mega/server/contracts/analytics'

type SnapshotQuery = { state: { data?: { expiresAt: string }; dataUpdatedAt: number } }
// 客户端遵循服务端快照到期时间，避免在一小时旧缓存上再叠加一小时 freshness。
export const snapshotQueryOptions = {
  staleTime: (query: SnapshotQuery) =>
    query.state.data
      ? Math.max(0, dayjs(query.state.data.expiresAt).valueOf() - query.state.dataUpdatedAt)
      : ANALYTICS_TTL,
  refetchInterval: (query: SnapshotQuery) =>
    query.state.data ? Math.max(1000, dayjs(query.state.data.expiresAt).valueOf() - dayjs().valueOf()) : ANALYTICS_TTL
}
